import { SHOW_LOGIN_MODAL, HIDE_LOGIN_MODAL } from '../../actions/actionTypes';

const initialState = {
    showLoginModal: false
};

const modalReducer = (state = initialState, action) => {
    if (typeof state === 'undefined') {
        return initialState;
    }
    switch (action.type) {
        case SHOW_LOGIN_MODAL:
            return Object.assign({}, state, {
                showLoginModal: true
            });
        case HIDE_LOGIN_MODAL:
            return Object.assign({}, state, {
                showLoginModal: false
            });
        default:
            return state;
    }
};

export default modalReducer;
